<template>
  <section class="hospital-events">
    <!-- ===== HEADER ===== -->
    <header class="events-header">
      <h1>Dokumentasi Kegiatan</h1>
      <p>
        Dokumentasi berbagai kegiatan yang telah diselenggarakan oleh RSKJP Melinda CVC, sebagai bentuk komitmen kami dalam pelayanan, edukasi, dan pengabdian masyarakat.
      </p>
    </header>

    <!-- ===== EVENTS GRID (IMAGE ONLY) ===== -->
    <div class="events-grid" v-if="events.length">
      <div
        class="event-image-only"
        v-for="event in events"
        :key="event.id"
        @click="openEvent(event)"
      >
        <img :src="event.images[0]" :alt="event.name" />
        <h3>{{ event.name }}</h3>
      </div>
    </div>

    <div class="no-events" v-else>
      <p>Belum ada dokumentasi kegiatan untuk saat ini.</p>
    </div>

    <!-- ===== MODAL CAROUSEL ===== -->
    <transition name="fade">
      <div v-if="activeEvent" class="hemov" @click.self="closeModal">
        <button class="close-btn" @click="closeModal">x</button>
        <div class="hemct">
          <!-- <h2 class="modal-title">{{ activeEvent.name }}</h2> -->

          <Swiper
            :modules="swiperModules"
            :navigation="false"
            :pagination="{ clickable: true }"
            loop
            class="event-swiper"
          >
            <SwiperSlide v-for="(img, idx) in activeEvent.images" :key="idx">
              <img :src="img" :alt="`${activeEvent.name} - ${idx + 1}`" />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </transition>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const swiperModules = [Navigation, Pagination]

/* ===== Dummy Data ===== */
const events = [
  {
    id: 1,
    name: 'Donor Darah Bersama',
    date: '1 Juli 2025',
    location: 'Lobby Utama',
    images: [
      new URL('@/assets/images/events/event1.JPG', import.meta.url).href,
      new URL('@/assets/images/events/event1.JPG', import.meta.url).href,
      new URL('@/assets/images/events/event1.JPG', import.meta.url).href,
    ],
  },
  {
    id: 2,
    name: 'Senam Jantung Sehat',
    date: '10 Juni 2025',
    location: 'Halaman Depan RSKJP',
    images: [
      new URL('@/assets/images/events/event2.JPG', import.meta.url).href,
      new URL('@/assets/images/events/event2.JPG', import.meta.url).href,
    ],
  },
  {
    id: 3,
    name: 'Penyuluhan Hipertensi',
    date: '18 Mei 2025',
    location: 'Ruang Edukasi',
    images: [
      new URL('@/assets/images/events/event3.JPG', import.meta.url).href,
      new URL('@/assets/images/events/event3.JPG', import.meta.url).href,
    ],
  },
  {
    id: 4,
    name: 'Judul Event',
    date: '1 Mei 2025',
    location: 'Ruang Edukasi',
    images: [
      new URL('@/assets/images/events/event4.JPG', import.meta.url).href,
      new URL('@/assets/images/events/event4.JPG', import.meta.url).href,
    ],
  },
]

/* ===== Modal State ===== */
const activeEvent = ref(null)
function openEvent(evt) {
  activeEvent.value = evt
}
function closeModal() {
  activeEvent.value = null
}
</script>

<style scoped>
.hospital-events {
  padding: 2.5rem 10%;
  /* background: var(--white); */
  color: var(--navy);
}
.events-header {
  text-align: center;
  margin-bottom: 2rem;
}
.events-header h1 {
  font-size: 2rem;
  color: var(--white);
  margin: 0;
}
.events-header p {
  font-size: 1rem;
  color: var(--white);
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.event-image-only {
  cursor: pointer;
  text-align: center;
}
.event-image-only img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 6px;
  transition: transform 0.2s ease;
}
.event-image-only:hover img {
  transform: scale(1.02);
}
.event-image-only h3 {
  margin-top: 0.5rem;
  font-size: 1rem;
  color: var(--navy);
}

.no-events {
  text-align: center;
  font-size: 1.125rem;
  color: var(--grey);
  margin-top: 2rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.hemov {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}
.hemct {
  position: relative;
  width: 100%;
  max-width: 800px;
  /* background: var(--white); */
  /* border-radius: 10px; */
  padding: 2rem 1.5rem 2.5rem;
  /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2); */
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--white, #ffd000);
}
.modal-title {
  text-align: center;
  margin: 0 0 1.25rem;
  font-size: 1.5rem;
  color: var(--navy);
}
.event-swiper img {
  width: 100%;
  height: 450px;
  object-fit: cover;
  border-radius: 0;
  user-select: none;
}

@media (max-width: 1500px) {
  .hospital-events {
    padding: 2.5rem 5%;
  }
  .events-header h1 {
    font-size: 1.5rem;
  }
}
@media (max-width: 750px) {
  .hospital-events {
    padding: 1.5rem 2.5%;
  }
  .events-header h1 {
    font-size: 1.2rem;
  }
  .event-swiper img {
    height: 300px;
  }
  .hemct{
    padding: 0;
  }
}
</style>
